import ReportPurchasePrices from './ReportPurchasePrices';

export default ReportPurchasePrices;
